import React from "react";
import ReactDOM from "react-dom";
import OutputReportAdmin from "../../components/OutputReportAdmin/OutputReportAdmin";
import addMainMenuItem from "./AddMainMenuItem";

const addOutputReportAdmin = (api) => {
    const outputReportsButtonHandler = () => {
        const contentDiv = document.getElementById('ApplicationContent');
        if (null != contentDiv) {
            contentDiv.innerHTML = "";
            ReactDOM.render(
                <React.StrictMode>
                    <OutputReportAdmin api={api} />
                </React.StrictMode>,
                contentDiv
            );
        }
    }

    addMainMenuItem(5, outputReportsButtonHandler, "Output Reports");
}

export default addOutputReportAdmin;
